var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#dadada;stroke-width:1.5px;}.c{fill:#232323;}.d{fill:#1b1c1d;}.e{stroke:none;}.f{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 29,
    cy: 29,
    r: 29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 29,
    cy: 29,
    r: 28.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.709 16.831)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.063 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.439 0.42)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M167.048,113.96h-10.2a1.577,1.577,0,0,1-1.577-1.577v-20a1.577,1.577,0,0,1,1.577-1.577h10.2a1.577,1.577,0,0,1,1.577,1.577v20A1.577,1.577,0,0,1,167.048,113.96Z",
    transform: "translate(-155.268 -90.801)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.381 0.42)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M312.2,90.8h-.839V113.96h.839a1.577,1.577,0,0,0,1.577-1.577v-20A1.577,1.577,0,0,0,312.2,90.8Z",
    transform: "translate(-311.365 -90.801)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.439 3.861)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13.357,
    height: 14.378
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.381 3.861)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.416,
    height: 14.378
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M161.47,108.8h-10.2a2,2,0,0,1-2-2v-20a2,2,0,0,1,2-2h10.2a2,2,0,0,1,2,2v20A2,2,0,0,1,161.47,108.8Zm-10.2-23.159A1.158,1.158,0,0,0,150.11,86.8v20a1.158,1.158,0,0,0,1.157,1.157h10.2a1.158,1.158,0,0,0,1.157-1.157v-20a1.158,1.158,0,0,0-1.157-1.157Z",
    transform: "translate(-149.269 -84.802)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.645 0.526)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M224.231,111.148H218.55c-.353,0-.64-.188-.64-.421s.287-.421.64-.421h5.682c.353,0,.64.188.64.421S224.585,111.148,224.231,111.148Z",
    transform: "translate(-217.91 -110.307)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.437 3.733)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.952 5.729)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M324.84,219.783v2.969l1.562-2.113Z",
    transform: "translate(-324.84 -219.783)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.421 0.421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M288.726,147.979l5.432,2.976,3.417-6.9Z",
    transform: "translate(-288.726 -144.058)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M288.579,145.795a.42.42,0,0,1-.2-.052l-5.431-2.976a.421.421,0,0,1,.032-.753l8.849-3.921a.421.421,0,0,1,.547.571l-3.417,6.9a.421.421,0,0,1-.377.234Zm-4.483-3.357,4.3,2.357,2.706-5.462Z",
    transform: "translate(-282.727 -138.056)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.531 5.308)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M319.26,217.594a.421.421,0,0,1-.421-.421V214.2a.421.421,0,0,1,.623-.369l1.563.856a.42.42,0,0,1,.136.619l-1.562,2.113A.421.421,0,0,1,319.26,217.594Zm.421-2.68v.983l.517-.7Z",
    transform: "translate(-318.84 -213.784)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.531)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M319.26,144.205a.421.421,0,0,1-.271-.743l6.317-5.308a.421.421,0,0,1,.541.644l-6.317,5.308A.418.418,0,0,1,319.26,144.205Z",
    transform: "translate(-318.839 -138.056)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.351 4.956)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.421 0.421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M187.643,163.344v-1.831l1.705.916,1.705.916-1.705.916-1.705.916Z",
    transform: "translate(-187.643 -161.513)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M182.064,160.017a.421.421,0,0,1-.421-.421v-3.663a.421.421,0,0,1,.62-.371l3.411,1.831a.421.421,0,0,1,0,.741l-3.411,1.831A.42.42,0,0,1,182.064,160.017Zm.421-3.38v2.257l2.1-1.128Z",
    transform: "translate(-181.643 -155.513)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.788)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M95.329,187.461H93.943a2.909,2.909,0,0,1,0-5.818h3.863a.421.421,0,1,1,0,.841H93.943a2.068,2.068,0,0,0,0,4.136h1.386a.421.421,0,0,1,0,.841Z",
    transform: "translate(-91.034 -181.643)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.9c01d77ce2d3d0136e39f645a420e847.svg";
export { ForwardRef as ReactComponent };